import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-touch-point-layout-dialog',
  templateUrl: './touchPointLayoutDialog.component.html'
})
export class TouchPointLayoutDialogComponent implements OnChanges {
  @Input() visible: boolean;
  @Input() layoutData: any;
  @Input() activeFields: any[] = [];
  @Input() inactiveFields: any[] = [];
  @Input() renderSchemaViewer: boolean;
  @Input() missingLayout: boolean;

  @Output() close = new EventEmitter<void>();
  @Output() save = new EventEmitter<void>();
  @Output() removeField = new EventEmitter<any>();
  @Output() addField = new EventEmitter<any>();

  layoutDataForDisplay: any;

  constructor(private readonly translate: TranslateService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['layoutData'] || changes['activeFields'] || changes['renderSchemaViewer']) {
      this.buildLayoutDataForDisplay();
    }
  }

  private buildLayoutDataForDisplay() {
    if (!this.layoutData || !this.layoutData.form_schema || !this.layoutData.form_schema.properties) {
      this.layoutDataForDisplay = this.layoutData;
      return;
    }
    const copy = JSON.parse(JSON.stringify(this.layoutData));
    this.activeFields.forEach(field => {
      if (!field.isDet && copy.form_schema.properties[field.id]) {
        const activeLabel = this.translate.instant(field.label);
        const existingDesc = copy.form_schema.properties[field.id].description || '';
        copy.form_schema.properties[field.id].description = existingDesc
          ? existingDesc + ' [' + activeLabel + ']'
          : activeLabel;
      }
    });
    this.layoutDataForDisplay = copy;
  }
}


// WEBPACK FOOTER //
// ./src/app/views/promotion/touch-point/components/touchPointLayoutDialog.component.ts